import { Outlet } from '@tanstack/react-router';

import { AppHeader } from './AppHeader';
import { UserMenu } from './UserMenu';

export const RootLayout = () => (
  <div className="flex min-h-screen flex-col">
    <AppHeader right={<UserMenu />} />
    <main className="flex flex-1 flex-col">
      <Outlet />
    </main>
  </div>
);
